angular
  .module("ainapp")
  .controller("emailTemplatesController", ["app.config", function (config) {}]);

  angular
  .module("ainapp")
  .controller("emailTemplatesEditController", ["app.config", function (config) {}]);
